import { type OutlookAgentIframeProps } from './components/OutlookAgentIframe';
import { type OutlookAgentSdxPaneProps } from './components/OutlookAgentSdxPane';
import type * as lazyIndex from './lazyIndex';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "OutlookAgent" */ './lazyIndex'),
    { name: 'OutlookAgent' }
);

export const OutlookAgentIframe: LazyComponent<OutlookAgentIframeProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.OutlookAgentIframe);

export const OutlookAgentSdxPane: LazyComponent<OutlookAgentSdxPaneProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.OutlookAgentSdxPane);

export type { OutlookAgentIframeProps };
export type { OutlookAgentSdxPaneProps };

// Non-lazy synchronous routing contract — read by the Copilot pane/header/drawer and set by
// the ribbon "Agent Mode" button. Tiny, no side effects, safe to export eagerly.
export {
    isOutlookAgentModeActive,
    isOutlookAgentSdxActive,
    setOutlookAgentModeForced,
} from './state/outlookAgentMode';
